"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitProduct = exports.getTomatoWidth = exports.TomatoThreeWidth = exports.TomatoOneWidth = exports.TomatoTwoHalfWidth = exports.TomatoTwoWidth = void 0;
var utils_1 = require("pc/components/Products/ProductCardMini/utils");
var css_1 = require("mobile/utils/css");
exports.TomatoTwoWidth = 171;
exports.TomatoTwoHalfWidth = 141;
exports.TomatoOneWidth = 120;
exports.TomatoThreeWidth = 111;
exports.getTomatoWidth = function (col, customUI, isRollable) {
    var cardWidth;
    switch (col) {
        case 1:
            cardWidth = exports.TomatoOneWidth;
            break;
        case 2:
            if (isRollable) {
                cardWidth = exports.TomatoTwoHalfWidth;
            }
            else {
                cardWidth = exports.TomatoTwoWidth;
            }
            break;
        case 3:
            cardWidth = exports.TomatoThreeWidth;
            break;
        default:
            cardWidth = exports.TomatoTwoWidth;
    }
    return {
        imgWidth: css_1.px2rem(cardWidth),
        imgHeight: css_1.px2rem(cardWidth * utils_1.fetchProductPosterRadio(customUI === null || customUI === void 0 ? void 0 : customUI.shape))
    };
};
exports.getInitProduct = function (product) {
    var _a = product.img, img = _a === void 0 ? "" : _a, _b = product.name, name = _b === void 0 ? "" : _b, _c = product.price, price = _c === void 0 ? "" : _c, _d = product.originPrice, originPrice = _d === void 0 ? "" : _d, _e = product.url, url = _e === void 0 ? "" : _e;
    var _f = product === null || product === void 0 ? void 0 : product.extra, _g = _f.ltImg, ltImg = _g === void 0 ? "" : _g, _h = _f.rtImg, rtImg = _h === void 0 ? "" : _h, _j = _f.sold, sold = _j === void 0 ? "" : _j, _k = _f.star, star = _k === void 0 ? 0 : _k, _l = _f.titleImg, titleImg = _l === void 0 ? "" : _l, _m = _f.countdownToEnd, countdownToEnd = _m === void 0 ? "0" : _m, _o = _f.twentyTour, twentyTour = _o === void 0 ? "" : _o;
    return {
        img: img,
        name: name,
        price: price,
        originPrice: originPrice,
        url: url,
        ltImg: ltImg,
        rtImg: rtImg,
        sold: sold,
        star: star,
        titleImg: titleImg,
        countdownToEnd: countdownToEnd,
        twentyTour: twentyTour
    };
};
